export { SimpleProductHeader } from './simpleProductHeader';
